module.exports = __webpack_public_path__ + "img/empty_icon.42bc7b68.png";